module.exports = __webpack_public_path__ + "static/media/loading7.aacf324c.gif";